<!-- <div class="w-100 d-flex">


</div> -->
    <ng-content></ng-content>

@if ($showSave()) {
        <dx-button
            height="100%"
            width="100%"
            class="flex-grow-1 w-100"
            [elementAttr]="{ class: 'w-100 h-100' }"
            [type]="$saveType()!"
            [text]="$saveText()!"
            [icon]="saveIconClass()!"
            (onClick)="submit($event)"
            stylingMode="contained"
            [disabled]="$saveDisabled()!" />
    }
